import React from 'react';

const ThankYou = () => {
    return (
        <div className="min-h-screen bg-gradient-to-b from-[#404f6b] via-[#2f3a52] to-black text-white grid place-items-center px-4">
            <div className="w-full max-w-md rounded-2xl border border-white/10 bg-white/10 backdrop-blur-md p-6 text-center shadow-[0_20px_50px_-12px_rgba(250,204,21,0.25)]">
                <div className="mx-auto mb-4 h-12 w-12 rounded-full bg-emerald-500/20 ring-1 ring-emerald-400/30 grid place-items-center">
                    <svg viewBox="0 0 24 24" className="h-6 w-6 text-emerald-300">
                        <path
                            fill="currentColor"
                            d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
                        />
                    </svg>
                </div>

                <h1 className="text-2xl font-extrabold tracking-tight mb-2 bg-gradient-to-r from-yellow-300 via-amber-200 to-yellow-400 bg-clip-text text-transparent">
                    Thank You for Joining the Galactic Planner!
                </h1>

                <p className="text-indigo-100/90 mb-2">
                    Please do not close this page! Your submission has been received. You will be redirected to checkout shortly.
                    After the checkout process is done, you will receive the Galactic Planner within 10 minutes!
                </p>
                <p className="text-indigo-200">
                    If you don’t receive it or need help, visit our{" "}
                    <a
                        href="https://galacticplanner.com/pages/main-faqs"
                        className="text-yellow-300 hover:text-yellow-200 underline underline-offset-4"
                    >
                        FAQs Page
                    </a>{" "}
                    or contact us at{" "}
                    <a
                        href="mailto:hello@galacticplanner.com"
                        className="text-yellow-300 hover:text-yellow-200 underline underline-offset-4"
                    >
                        hello@galacticplanner.com
                    </a>.
                </p>
            </div>
        </div>
    );
};


export default ThankYou;
